import actions from "./actions";

const { FETCH_SUB_CLUB, FETCH_SUB_CLUBS, RESET_SUB_CLUB } = actions;

const initState = {
    subClubs: {
        page: 1,
        perPage: 10,
        data: [],
        total: 0
    },
    subClub: {
        _id: null,
        mainClub: null,
        serial: 1,
        name: "",
        code: "",
        description: "",
        photo: null,
        class: [],         // Array of Class Snapshots [{_id, name}]
        classId: null,
        status: "active",
        session: null,     // Session Snapshot {_id, startYear, endYear, isCurrent}
        sessionId: null,
        groupLeaders: [],  // Array of Student Snapshots
        teachers: [],      // Array of Teacher Snapshots
        visitors: []       // Array of Visitor Snapshots
    }
};

const SubClubReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_SUB_CLUBS:
            return {
                ...state,
                subClubs: {
                    page: data?.page || initState.subClubs.page,
                    perPage: data?.perPage || initState.subClubs.perPage,
                    total: data?.total || 0,
                    data: Array.isArray(data?.data) ? [...data.data] : []
                }
            };

        case RESET_SUB_CLUB:
            return {
                ...state,
                subClub: {
                    ...initState.subClub,
                    class: [],
                    groupLeaders: [],
                    teachers: [],
                    visitors: []
                }
            };

        case FETCH_SUB_CLUB:
            return {
                ...state,
                subClub: {
                    ...initState.subClub,
                    ...data,
                    // Fix: Preserve class as an array of snapshots
                    class: Array.isArray(data?.class) ? [...data.class] : [],
                    session: data?.session ? { ...data.session } : null,
                    groupLeaders: Array.isArray(data?.groupLeaders) ? [...data.groupLeaders] : [],
                    teachers: Array.isArray(data?.teachers) ? [...data.teachers] : [],
                    visitors: Array.isArray(data?.visitors) ? [...data.visitors] : []
                }
            };

        default:
            return state;
    }
};

export default SubClubReducer;